import { Box, Typography } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'

const NodeInput = ({
  text = '',
  value = '',
  onChange,
  disabled = false,
  ariaLabel,
}: {
  text?: string
  value?: string
  onChange?: (v: string) => void
  disabled?: boolean
  // Names the field for a screen reader when `text` is not enough.
  ariaLabel?: string
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.value)
  }

  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  const colors = {
    text: isDarkMode ? '#FFFFFF' : '#003F61',
    border: isDarkMode ? '#445876' : 'black',
    bg: isDarkMode ? '#0D192F' : '#fff',
    inputText: isDarkMode ? '#FFFFFF' : '#003F61',
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        justifyContent: 'flex-end',
      }}
    >
      {text && (
        <Typography
          sx={{
            color: colors.text,
            textAlign: 'right',
            fontFamily: 'Rubik, sans-serif',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 300,
            lineHeight: '100%',
          }}
        >
          {text}
        </Typography>
      )}
      {/* nodrag on the input only: typing and text selection must not start a
          node drag, while the label stays a drag area. */}
      <Box
        className="nodrag"
        sx={{
          direction: 'rtl',
          width: '100px',
          border: `1px solid ${colors.border}`,
          backgroundColor: colors.bg,
          height: '40px',
        }}
      >
        <input
          style={{
            overflow: 'hidden',
            color: colors.inputText,
            textAlign: 'right',
            textOverflow: 'ellipsis',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 300,
            lineHeight: '100%',
            backgroundColor: 'transparent',
            border: 'none',
            outline: 'none',
            width: '100%',
            height: '100%',
          }}
          type="text"
          value={value}
          onChange={handleChange}
          disabled={disabled}
          aria-label={ariaLabel ?? (text || undefined)}
        />
      </Box>
    </Box>
  )
}

export default NodeInput
